import { NotificationTypesEnum } from "@/model/data/enums/NotificationTypesEnum";
import { IPaginationFilter } from "../supportObjects/IPaginationFilter";

export class GetNotificationsReqData implements IPaginationFilter {
    startDate?: Date;
    endDate?: Date;
    notificationTypeListFilter: NotificationTypesEnum[];
    markedAsRead?: boolean;
    resultCode?: number;
    device: string;

    queryLimit: number;
    offset: number;
    orderBy: string[];
    orderByDescending: boolean[];
}
